<template>
<section>
    <v-container>
        <v-row justify="start">
          <v-toolbar-title
            class="grey--text text--darken-4 font-weight-black my-5 ml-12"
            >
            Stock Balance
          </v-toolbar-title>
           <v-spacer />
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
          >
          </v-text-field>
           <v-spacer />
          <div class="text-center">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  append-icon="filter_alt"
                  v-model="searchResident"
                  label="Filter By Resident"
                  single-line
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  />
              </template>
              <v-list style="max-height: 100px" v-model="searchResident">
                <v-list-item
                  v-for="(item, index) in residents"
                  :key="index"
                  v-bind="item"
                >
                  <v-list-item-title  @click="medicationByResident(item)">{{ item.fullName }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="medications"
          :options.sync="options"
          :server-items-length="totalMedications"
          :loading="loading"
          loading-text="Loading ..... Please wait"
          :footer-props="{
            itemsPerPageOptions: [ 500, 1000, 2000],
            itemsPerPageText: 'Stock Balance per page',
          }"
          update:options
          class="elevation-23"
        >
            <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-dialog v-model="dialog" max-width="800px" persistent>

                      <v-card class="edit-modal-card">
                        <v-card-title class="primary white--text">
                          <v-icon left color="white">edit</v-icon>
                          Edit Medication
                        </v-card-title>
                        <v-card-text class="pa-6">
                          <v-container fluid>
                            <!-- Basic Information Section -->
                            <div class="mb-6">
                              <h3 class="text-h6 mb-4 primary--text">
                                <v-icon left color="primary">medication</v-icon>
                                Basic Information
                              </h3>
                              <v-row>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field 
                                    v-model="editedItem.name" 
                                    label="Medication Name" 
                                    prepend-icon="medication"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field 
                                    v-model="editedItem.directive" 
                                    label="Directive"
                                    prepend-icon="assignment"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                  <v-text-field 
                                    v-model="editedItem.description" 
                                    label="Description"
                                    prepend-icon="description"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                            <!-- Quantity Section -->
                            <div class="mb-6">
                              <h3 class="text-h6 mb-4 primary--text">
                                <v-icon left color="primary">inventory</v-icon>
                                Quantity Information
                              </h3>
                              <v-row>
                                <v-col cols="12" sm="6">
                                  <v-text-field 
                                    v-model="editedItem.quantity.order" 
                                    label="Quantity Order"
                                    type="number"
                                    prepend-icon="shopping_cart"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                  <v-text-field 
                                    v-model="editedItem.quantity.receive" 
                                    label="Quantity Received"
                                    type="number"
                                    prepend-icon="check_circle"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                            <!-- Date Section -->
                            <div class="mb-6">
                              <h3 class="text-h6 mb-4 primary--text">
                                <v-icon left color="primary">event</v-icon>
                                Date Information
                              </h3>
                              <v-row>
                                <v-col cols="12" sm="6">
                                  <v-menu
                                    v-model="editedItem.menu1"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="editedItem.startDate"
                                        label="Start Date"
                                        prepend-icon="event"
                                        readonly
                                        outlined
                                        dense
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-datetime-picker
                                      v-model="editedItem.startDate" 
                                      timePickerFormat="24hr"
                                      dateFormat="dd-MM-yyyy">
                                    </v-datetime-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" sm="6">
                                  <v-menu
                                    v-model="editedItem.menu2"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="editedItem.endDate"
                                        label="End Date"
                                        prepend-icon="event"
                                        readonly
                                        outlined
                                        dense
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-datetime-picker 
                                      no-title 
                                      scrollable
                                      v-model="editedItem.endDate" 
                                      timePickerFormat="24hr"
                                      dateFormat="dd-MM-yyyy">
                                    </v-datetime-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </div>
                                
                            <!-- Schedule Section -->
                            <div class="mb-6">
                              <v-divider class="mb-4"></v-divider>
                              <h3 class="text-h6 mb-4 primary--text">
                                <v-icon left color="primary">schedule</v-icon>
                                Medication Schedule
                              </h3>
                              
                              <!-- Schedule Time -->
                              <v-row class="mb-4">
                                <v-col cols="12" sm="6">
                                  <v-menu
                                    v-model="editedItem.scheduleTimeMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="editedItem.scheduleTime"
                                        label="Administration Time"
                                        prepend-icon="access_time"
                                        readonly
                                        outlined
                                        dense
                                        hint="Select the time for medication administration"
                                        persistent-hint
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-time-picker 
                                      v-model="editedItem.scheduleTime" 
                                      no-title 
                                      scrollable
                                      @input="editedItem.scheduleTimeMenu = false"
                                      format="24hr"
                                    >
                                    </v-time-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>

                              <!-- Days of Week Checkboxes -->
                              <div class="mb-4">
                                <v-subheader class="px-0 text-subtitle-1 font-weight-medium">
                                  <v-icon left small color="primary">calendar_today</v-icon>
                                  Select days when medication is needed:
                                </v-subheader>
                                <v-row class="mt-2">
                                  <v-col cols="6" sm="4" md="3" v-for="day in daysOfWeek" :key="day.value">
                                    <v-card 
                                      :class="['day-card', editedItem.schedule[day.value] ? 'selected-day' : 'unselected-day']"
                                      flat
                                    >
                                      <v-card-text class="pa-2 text-center">
                                        <v-checkbox
                                          v-model="editedItem.schedule[day.value]"
                                          :label="day.label"
                                          color="primary"
                                          hide-details
                                          class="ma-0"
                                          @change="console.log('Day changed:', day.value, editedItem.schedule[day.value])"
                                        ></v-checkbox>
                                      </v-card-text>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </v-container>
                        </v-card-text>

                        <v-card-actions class="pa-6 pt-0">
                          <v-spacer></v-spacer>
                          <v-btn 
                            color="grey" 
                            outlined 
                            @click="close"
                            class="mr-3"
                          >
                            <v-icon left>close</v-icon>
                            Cancel
                          </v-btn>
                          <v-btn 
                            color="primary" 
                            @click="save"
                            :loading="loading"
                          >
                            <v-icon left>save</v-icon>
                            Save Changes
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row justify="space-around">
                      <span class="group pa-2">
                          <v-icon
                            v-if="$can('update')"
                            small
                            class="mr-2"
                            @click="editItem(item)"
                          >
                            edit
                          </v-icon>
                          <v-icon
                            v-if="$can('delete')"
                            small
                            @click="deleteItem(item)"
                          >
                            delete
                          </v-icon>
                            <v-icon v-if="$can('read')" medium @click="detail_medication(item)">info</v-icon>
                            <v-icon 
                              v-if="$can('read')" 
                              medium 
                              class="ml-2"
                              @click="showMedicationProfile(item)"
                            >
                              mdi-account-card-details
                            </v-icon>
                      </span>
                  </v-row>
                </template>
        </v-data-table>
         <div class="table-footer-prepend d-flex pl-2 align-center"  v-if='selectedId'>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                class="mr-3"
                v-on="on"
                @click="addNew()"
              >
              Register
              </v-btn>
            </template>
            <span>Register new medication</span>
          </v-tooltip>
         </div>
    </v-container>
    <MedicationProfileDialog
      v-model="profileDialog"
      :resident="residentProfile"
      :loading="profileLoading"
    />
</section>
</template>
<script>
import {  mapActions } from 'vuex'
import medicationApi from '../../services/api/MedicationApi';
import residentApi from '@/services/api/ResidentApi';
import moment from 'moment';
import MedicationProfileDialog from './MedicationProfileDialog.vue';
export default {
    name: 'medication',
    components: {
        MedicationProfileDialog
    },
    data () {
        return {
            dialog: false,
            profileDialog: false,
            profileLoading: false,
            residentProfile: null,
            medications: [],
            residents: [],
            totalMedications: 0,
            loading: true,
            options: {},
            search: '',
            searchResident: '',
            selectedId:'',
            daysOfWeek: [
                { value: 'monday', label: 'Monday' },
                { value: 'tuesday', label: 'Tuesday' },
                { value: 'wednesday', label: 'Wednesday' },
                { value: 'thursday', label: 'Thursday' },
                { value: 'friday', label: 'Friday' },
                { value: 'saturday', label: 'Saturday' },
                { value: 'sunday', label: 'Sunday' }
            ],
             headers: [
                { text: 'Medication Name', value: 'name', class: 'success--text font-weight-bold' },
                { text: 'Resident', value: 'resident.fullName',class: 'success--text font-weight-bold' },
                { text: 'Description', value: 'description', sortable: false, class: 'success--text font-weight-bold'  },
                { text: 'Date Received', value: 'receiveTime', class: 'success--text font-weight-bold' },
                { text: 'Quantity Received', value: 'quantity.receive', class: 'success--text font-weight-bold' },
                { text: 'Quantity Remaining', value: 'quantity.remaining', class: 'success--text font-weight-bold' },
                { text: 'Actions', value: 'action', sortable: false, class: 'success--text font-weight-bold', width: '7rem' },
            ],
              editedItem: {
                name: '',
                directive: '',
                description: '',
                quantity: {
                  order: null,
                  receive: null,
                },
                startDate: null,
                endDate: null,
                menu1: false,
                menu2: false,
                scheduleTime: '',
                scheduleTimeMenu: false,
                schedule: {
                  monday: false,
                  tuesday: false,
                  wednesday: false,
                  thursday: false,
                  friday: false,
                  saturday: false,
                  sunday: false
                }
              },
              defaultItem: {
                name: '',
                description: '',
                receiveTime: '',
                quantity: {
                  order: null,
                  receive: null,
                },
              },
        }
    },
    methods: {
        ...mapActions([
            'update_medication',
        ]),
        editItem (item) {
            this.editedItem = Object.assign({}, item)
            this.defaultItem.startDate = item.startDate;
            this.defaultItem.endDate = item.endDate;
            
            // Initialize schedule data if not present
            if (!this.editedItem.schedule) {
                this.editedItem.schedule = {
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false
                }
            }
            if (!this.editedItem.scheduleTime) {
                this.editedItem.scheduleTime = ''
            }
            
            this.dialog = true
        },
        deleteItem (item) {
          confirm('Are you sure you want to delete this medication?') && this.delete_medication(item)
          const index = this.medications.indexOf(item)
          this.medications.splice(index, 1)
        },

        close () {
          this.dialog = false
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300)
        },
        save () {
            delete this.editedItem.resident;
            delete this.editedItem.createdOn;
            delete this.editedItem.modifiedOn;
            delete this.editedItem.receiveTime;
            delete this.editedItem.quantity.value;
            delete this.editedItem.user;
            if (this.defaultItem.startDate != this.editedItem.startDate){
               this.editedItem.startDate = this.formatDate(this.editedItem.startDate);
            }
            if (this.defaultItem.endDate != this.editedItem.endDate){
              this.editedItem.endDate=this.formatDate(this.editedItem.endDate);
            }
            this.update_medication({...this.editedItem})
          this.close()
        },
        get_registered_medication_list () {
          this.loading = true
          return new Promise((resolve, reject) => {
              const { sortBy, sortDesc, page, itemsPerPage } = this.options
              // console.log(sortDesc);
              if (sortDesc&& sortDesc.length && sortDesc[0] == false){
                var orde = 'asc'
              }
              else{
                 orde = 'desc'
              }
              if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                var homeId = ''
              }
              else{
                homeId = localStorage.getItem('homeId')
              }
              medicationApi.getAllMedication({page: page, count:itemsPerPage, id:'', q:'', orderBy: sortBy && sortBy[0], order: orde})
                .then(medications => {
                    if (homeId.toString().length > 0 ){
                        this.medications = medications.result.filter(medication => medication.resident.home.homeId==homeId)
                        this.totalMedications = this.medications.length
                    }
                    else{
                        this.medications = medications.result
                        this.totalMedications = medications.count
                    }
                })
                .catch(error => {
                    return reject(error)
                })

              setTimeout(() => {
                this.loading = false
                }, 1000)
          })
        },
        delete_medication(item) {
            medicationApi.deleteRegisteredMedication(item.id)
                .then(medication => {
                    return ("deleted" + medication);
                })
        },
        detail_medication(medication){
          this.$router.push({ name: 'medicationDetail', params: {medicationId:medication.id, residentId:medication.resident.id}})
        },
        formatDate(date) {
          return moment(date).format('DD-MM-YYYY HH:mm')
      },
      get_resident_list () {
          // this.loading = true
          // if(this.searchResident.length>0){
              return new Promise((resolve, reject) => {
                  if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homecode = ''
                  }
                  else{
                    homecode = localStorage.getItem('homeCode')
                  }
                  residentApi.getResidents({page: '', count:'', home:homecode, q:''})
                    .then(residents => {
                        this.residents = residents.result
                        this.totalResidents = residents.count
                    }).catch(error => {
                        return reject(error)
                    })
                  setTimeout(() => {
                    this.loading = false
                    }, 1000)
              })
        },
      medicationByResident(resident) {
          var id = resident.id;
          this.selectedId = resident.id;
          this.searchResident = resident.fullName
          return new Promise((resolve, reject) => {
                  medicationApi.getRegisteredMedication({page:'', count:'', id:id, q:''})
                    .then(medications => {
                      this.medications = medications.result
                      this.totalMedications = medications.count
                    })
                    .catch(error => {
                      return reject(error)
                    })
                })
      },
      addNew () {
        this.$router.push({ name: 'registerMedication', params: {residentId:this.selectedId}});
      },
      async showMedicationProfile(item) {
        if (!item.resident || !item.resident.id) {
          alert('Resident information not available');
          return;
        }
        
        this.profileLoading = true;
        this.profileDialog = true;
        
        try {
          const response = await residentApi.getResident(item.resident.id);
          this.residentProfile = response.response;
          
          // Parse medical history if it's a text string
          if (this.residentProfile.medicalHistory && typeof this.residentProfile.medicalHistory === 'string') {
            // Split by common delimiters (newlines, commas, semicolons)
            this.residentProfile.medicalHistoryList = this.residentProfile.medicalHistory
              .split(/[\n,;]/)
              .map(item => item.trim())
              .filter(item => item.length > 0);
          } else {
            this.residentProfile.medicalHistoryList = [];
          }
        } catch (error) {
          console.error('Error fetching resident profile:', error);
          alert('Failed to load resident profile');
          this.profileDialog = false;
        } finally {
          this.profileLoading = false;
        }
      },
    },
    created() {
        this.get_registered_medication_list();
    },
    beforeMount(){
      this.get_resident_list();
    },
    computed:{
       filteredCustomers:function(){
        var self=this;
        return this.residents.filter(function(cust){return cust.fullName.toLowerCase().indexOf(self.searchResident.toLowerCase())>=0;});
        }
    },
    watch: {
        options: {
          handler () {
            this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          },
          deep: true,
        },
        dialog (val) {
          val || this.close()
        },
        editedItem: function() {
          this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
        },
        search: function() {
          this.searchResident = ''
          this.selectedId = ''
          if(this.search.length > 0){
            try{
                const medication = this.medications.find(x => (x.resident.fullName === this.search||x.resident.firstName === this.search));
                const id = medication.resident.id;
              if (id){
                return new Promise((resolve, reject) => {
                  medicationApi.getRegisteredMedication({page:'', count:'', id:id, q:''})
                    .then(medications => {
                      this.medications = medications.result
                      this.totalMedications = medications.count
                    })
                    .catch(error => {
                      return reject(error)
                    })
                })
                }
              }
            catch(err){
                return new Promise((resolve, reject) => {
                  if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homeId = ''
                  }
                  else{
                    homeId = localStorage.getItem('homeId')
                  }
                  medicationApi.getRegisteredMedication({page:'', count:'', id:'', q:this.search})
                    .then(medications => {
                      if (homeId.toString().length > 0 ){
                        this.medications = medications.result.filter(medication => medication.resident.home.homeId==homeId)
                        this.totalMedications = this.medications.length
                      }
                      else{
                        this.medications = medications.result
                        this.totalMedications = medications.count
                      }
                    })
                    .catch(error => {
                      return reject(error)
                    })
                })
             }
          }
          if(this.search.length <= 0){
            this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          }
        },
        searchResident: function(){
            if(this.searchResident.length <= 0){
              this.selectedId = ''
            this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
            this.get_resident_list();
            }
            else if(this.searchResident.length >0){
              return new Promise((resolve, reject) => {
                  if (['Admin', 'Administrator', 'Director', 'Supervisor', 'CCSO', 'CEO'].includes(localStorage.getItem('role'))){
                    var homecode = ''
                  }
                  else{
                    homecode = localStorage.getItem('homeCode')
                  }
                  residentApi.getResidents({page:'', count:'', home:homecode, q:this.searchResident})
                    .then(residents => {
                        this.residents = residents.result
                        this.totalResidents = residents.count
                    }).catch(error => {
                        return reject(error)
                    })
                  setTimeout(() => {
                    this.loading = false
                    }, 1000)
              })
          }
        },
    },
}
</script>
<style lang="scss">
  #input {
    width:70%;
  }
  .table-footer-prepend {
    margin-top: -58px;
    height: 58px;
    margin-left: 400px;
  }

/* Enhanced Modal Styles */
.edit-modal-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.edit-modal-card .v-card__title {
  border-radius: 12px 12px 0 0 !important;
  padding: 20px 24px !important;
}

.day-card {
  border: 2px solid #e0e0e0 !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.day-card:hover {
  border-color: #1976d2 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15) !important;
}

.selected-day {
  border-color: #1976d2 !important;
  background-color: rgba(25, 118, 210, 0.05) !important;
}

.unselected-day {
  border-color: #e0e0e0 !important;
  background-color: #fafafa !important;
}

/* Section Headers */
.text-h6 {
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
}

/* Form Field Enhancements */
.v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 48px !important;
}

.v-text-field--outlined .v-label {
  font-weight: 500 !important;
}

/* Button Enhancements */
.v-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .edit-modal-card {
    margin: 16px !important;
  }
  
  .day-card {
    margin-bottom: 8px !important;
  }
}
</style>
